export type Region = "日本" | "中国" | "欧美" | "韩国";

export interface Anime {
  id: string;
  title: string;
  cover: string;
  year: number;
  region: Region;
  categories: string[];
  episodes: number;
  status: "连载中" | "已完结";
  rating: number;
  popularity: number;
  summary: string;
  updatedAt: string;
  studio: string;
  voiceCast: string[];
  colorTag: string;
}

export const animeList: Anime[] = [
  {
    id: "star-voyage-01",
    title: "星海航线",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20space%20explorer%20standing%20on%20a%20spaceship%20deck%2C%20deep%20navy%20starry%20sky%20background%2C%20warm%20orange%20glowing%20engine%20light%2C%20clean%20vibrant%20cel%20shaded%20art%2C%20portrait%20poster%20composition%2C%20high%20detail&width=600&height=840&seq=anime-cover-01&orientation=portrait",
    year: 2025,
    region: "日本",
    categories: ["科幻", "冒险", "热血"],
    episodes: 24,
    status: "连载中",
    rating: 9.3,
    popularity: 9850,
    summary: "少年航行士在一次意外跃迁中被抛入未知星域，他必须依靠一艘老旧飞船与一群性格古怪的同伴，在星海间寻找回家的航线，同时揭开被星际议会掩埋的真相。",
    updatedAt: "2026-10-16",
    studio: "光年动画工房",
    voiceCast: ["青木遥", "森川凛", "宫下翔太"],
    colorTag: "from-primary-600 to-primary-800",
  },
  {
    id: "spirit-sword-02",
    title: "灵剑少年录",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20teenage%20swordsman%20holding%20a%20glowing%20jade%20sword%2C%20misty%20mountain%20temple%20background%2C%20warm%20sunset%20orange%20accents%2C%20cel%20shaded%20vibrant%20art%2C%20portrait%20poster%2C%20high%20detail&width=600&height=840&seq=anime-cover-02&orientation=portrait",
    year: 2024,
    region: "中国",
    categories: ["热血", "奇幻", "武侠"],
    episodes: 40,
    status: "连载中",
    rating: 9.0,
    popularity: 9320,
    summary: "山间少年偶然唤醒沉睡千年的灵剑，被迫卷入九大剑派的纷争。他用一柄不听话的剑，和一颗不肯认输的心，重写整个江湖的规则。",
    updatedAt: "2026-10-17",
    studio: "云麓动画",
    voiceCast: ["李行舟", "沈清歌", "白无常"],
    colorTag: "from-accent-600 to-accent-800",
  },
  {
    id: "sakura-letter-03",
    title: "樱色信笺",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20two%20high%20school%20students%20on%20a%20bridge%20with%20cherry%20blossoms%2C%20pink%20petals%20floating%2C%20soft%20warm%20light%2C%20gentle%20romantic%20cel%20shaded%20art%2C%20portrait%20poster%20composition%2C%20high%20detail&width=600&height=840&seq=anime-cover-03&orientation=portrait",
    year: 2023,
    region: "日本",
    categories: ["恋爱", "校园", "治愈"],
    episodes: 12,
    status: "已完结",
    rating: 8.8,
    popularity: 8760,
    summary: "转学生收到一封没有署名的信，信里写着十年后的约定。在樱花落尽的季节里，两个人用一整个夏天去寻找写信的人究竟是谁。",
    updatedAt: "2026-09-21",
    studio: "花见工作室",
    voiceCast: ["水野杏", "桐生悠真"],
    colorTag: "from-accent-400 to-accent-600",
  },
  {
    id: "mecha-dawn-04",
    title: "机甲黎明",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20giant%20mecha%20robot%20in%20a%20ruined%20city%20at%20dawn%2C%20orange%20sunrise%20light%20and%20steel%20blue%20shadows%2C%20dramatic%20cel%20shaded%20art%2C%20portrait%20poster%2C%20high%20detail&width=600&height=840&seq=anime-cover-04&orientation=portrait",
    year: 2025,
    region: "日本",
    categories: ["机甲", "科幻", "热血"],
    episodes: 26,
    status: "连载中",
    rating: 9.1,
    popularity: 9410,
    summary: "当天空被钢铁巨影遮蔽，一名维修工少年驾驶着未完成的原型机站上战场。他说自己不是英雄，只是不想再听见城市的哭声。",
    updatedAt: "2026-10-15",
    studio: "铁翼制作",
    voiceCast: ["大河内隼", "佐伯澪"],
    colorTag: "from-primary-700 to-secondary-700",
  },
  {
    id: "spirit-shop-05",
    title: "夏日祭的幽灵杂货铺",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cozy%20old%20japanese%20shop%20with%20lanterns%20at%20summer%20festival%20night%2C%20friendly%20ghost%20shoppers%2C%20warm%20orange%20lantern%20glow%2C%20cel%20shaded%20cozy%20art%2C%20portrait%20poster&width=600&height=840&seq=anime-cover-05&orientation=portrait",
    year: 2024,
    region: "日本",
    categories: ["奇幻", "治愈", "日常"],
    episodes: 12,
    status: "已完结",
    rating: 8.9,
    popularity: 7320,
    summary: "只在夏夜开门的杂货铺，卖给活人一点回忆，卖给幽灵一点时间。店主是个记性不太好的女孩，和一只爱偷吃团子的猫又。",
    updatedAt: "2026-08-30",
    studio: "灯屋动画",
    voiceCast: ["白石绫", "猫又丸"],
    colorTag: "from-accent-500 to-accent-700",
  },
  {
    id: "sky-athlete-06",
    title: "天空的排球部",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20high%20school%20volleyball%20players%20jumping%20in%20a%20bright%20gymnasium%2C%20dynamic%20action%20pose%2C%20sunlight%20through%20windows%2C%20energetic%20cel%20shaded%20sports%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-06&orientation=portrait",
    year: 2022,
    region: "日本",
    categories: ["运动", "热血", "校园"],
    episodes: 25,
    status: "已完结",
    rating: 9.2,
    popularity: 8900,
    summary: "身高不够、天赋一般、还怕球砸脸。这样一个少年，偏偏要打进全国大赛。他的队伍只有一个共同点：谁都不肯先认输。",
    updatedAt: "2026-07-12",
    studio: "跃动社",
    voiceCast: ["小野寺翔", "加藤海斗"],
    colorTag: "from-primary-500 to-primary-700",
  },
  {
    id: "midnight-detective-07",
    title: "午夜侦探社",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20under%20rainy%20neon%20city%20street%20at%20night%2C%20moody%20orange%20street%20lamps%2C%20cel%20shaded%20mystery%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-07&orientation=portrait",
    year: 2025,
    region: "日本",
    categories: ["悬疑", "推理", "都市"],
    episodes: 18,
    status: "连载中",
    rating: 8.7,
    popularity: 7150,
    summary: "只在午夜接案的侦探社，委托人从来不带影子。一件失窃的旧怀表，牵出整座城市被遗忘的十年。",
    updatedAt: "2026-10-14",
    studio: "雨夜映画",
    voiceCast: ["黑木徹", "野村千夏"],
    colorTag: "from-secondary-600 to-secondary-800",
  },
  {
    id: "dragon-chef-08",
    title: "异世界食堂物语",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cute%20dragon%20chef%20cooking%20in%20a%20warm%20fantasy%20kitchen%2C%20steaming%20food%20on%20wooden%20table%2C%20cozy%20orange%20light%2C%20cel%20shaded%20fantasy%20food%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-08&orientation=portrait",
    year: 2023,
    region: "日本",
    categories: ["奇幻", "日常", "治愈"],
    episodes: 13,
    status: "已完结",
    rating: 8.6,
    popularity: 6540,
    summary: "一扇通往异世界的门开在小食堂的后厨。巨龙、精灵、魔王都会来吃一碗热面，而老板娘只关心今天的高汤够不够鲜。",
    updatedAt: "2026-06-18",
    studio: "暖锅工作室",
    voiceCast: ["三谷梅", "龙主阿雷"],
    colorTag: "from-accent-600 to-accent-900",
  },
  {
    id: "dark-city-09",
    title: "暗巷之城",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20stylish%20courier%20riding%20a%20motorcycle%20through%20a%20dark%20narrow%20alley%20with%20orange%20signs%2C%20cinematic%20lighting%2C%20cel%20shaded%20cyberpunk%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-09&orientation=portrait",
    year: 2024,
    region: "中国",
    categories: ["科幻", "悬疑", "都市"],
    episodes: 16,
    status: "已完结",
    rating: 8.5,
    popularity: 6010,
    summary: "在这座城市，记忆可以运输，也可以被偷。一名跑单的快递员，接到了送达自己童年记忆的订单。",
    updatedAt: "2026-05-09",
    studio: "夜行社",
    voiceCast: ["程野", "苏晓", "老猫"],
    colorTag: "from-primary-800 to-primary-950",
  },
  {
    id: "forest-guardian-10",
    title: "森林守护者",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20girl%20with%20a%20deer%20companion%20in%20a%20sunlit%20ancient%20forest%2C%20glowing%20spirits%2C%20green%20and%20warm%20amber%20tones%2C%20cel%20shaded%20fantasy%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-10&orientation=portrait",
    year: 2021,
    region: "日本",
    categories: ["奇幻", "冒险", "治愈"],
    episodes: 24,
    status: "已完结",
    rating: 8.4,
    popularity: 5620,
    summary: "森林沉睡了三百年，直到一个迷路的女孩踩碎了最后一道封印。她必须带着一群小精灵，把被偷走的四季重新找回。",
    updatedAt: "2026-03-22",
    studio: "绿荫动画",
    voiceCast: ["小森野花", "鹿灵奈"],
    colorTag: "from-accent-400 to-accent-700",
  },
  {
    id: "comedy-friends-11",
    title: "放学后的和平委员会",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20four%20cheerful%20high%20school%20friends%20in%20a%20colorful%20club%20room%20after%20class%2C%20sunset%20light%2C%20playful%20comedy%20cel%20shaded%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-11&orientation=portrait",
    year: 2025,
    region: "日本",
    categories: ["校园", "搞笑", "日常"],
    episodes: 12,
    status: "连载中",
    rating: 8.3,
    popularity: 5980,
    summary: "一个为了阻止社团被解散而成立的委员会，成员包括睡神、学神、吃货和一位自称未来人的转学生。和平？先别打起来就谢天谢地了。",
    updatedAt: "2026-10-13",
    studio: "笑声制作",
    voiceCast: ["早川未来", "小林大福"],
    colorTag: "from-accent-500 to-accent-800",
  },
  {
    id: "tower-fantasy-12",
    title: "琉璃塔的守望者",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20tall%20glowing%20glass%20tower%20in%20a%20desert%20at%20sunset%20with%20a%20lone%20traveler%20in%20a%20cloak%2C%20warm%20amber%20sky%2C%20cel%20shaded%20fantasy%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-12&orientation=portrait",
    year: 2024,
    region: "中国",
    categories: ["奇幻", "冒险", "热血"],
    episodes: 36,
    status: "连载中",
    rating: 8.9,
    popularity: 8120,
    summary: "传说塔顶封存着世界的第一句话。九十九层，九十九位守塔人，只有一个人能带着答案走出来。",
    updatedAt: "2026-10-12",
    studio: "琉璃染坊",
    voiceCast: ["顾长明", "阿窕"],
    colorTag: "from-accent-500 to-primary-700",
  },
  {
    id: "mystic-cat-13",
    title: "猫咪事务所",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20sleek%20black%20cat%20wearing%20tiny%20glasses%20sitting%20on%20a%20desk%20of%20a%20small%20detective%20office%2C%20warm%20lamp%20light%2C%20charming%20cel%20shaded%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-13&orientation=portrait",
    year: 2022,
    region: "日本",
    categories: ["搞笑", "日常", "悬疑"],
    episodes: 20,
    status: "已完结",
    rating: 8.2,
    popularity: 4900,
    summary: "一个失业青年与一只自称名侦探的猫合开事务所。委托千奇百怪，报酬通常是一罐高级猫粮。",
    updatedAt: "2026-02-14",
    studio: "喵太动画",
    voiceCast: ["猫田教授", "山口零"],
    colorTag: "from-secondary-500 to-secondary-700",
  },
  {
    id: "snow-singer-14",
    title: "雪夜歌姬",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20female%20singer%20on%20stage%20in%20falling%20snow%2C%20warm%20spotlights%20against%20cool%20night%20blue%2C%20graceful%20cel%20shaded%20music%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-14&orientation=portrait",
    year: 2023,
    region: "韩国",
    categories: ["音乐", "恋爱", "治愈"],
    episodes: 12,
    status: "已完结",
    rating: 8.8,
    popularity: 6880,
    summary: "她只会在地下通道唱歌，直到一个冬天，整座城市都听见了她的声音。而那天的雪，只为一场告别而下。",
    updatedAt: "2026-01-08",
    studio: "白噪映画",
    voiceCast: ["尹瑞雅", "姜贤宇"],
    colorTag: "from-secondary-600 to-primary-800",
  },
  {
    id: "academy-magic-15",
    title: "魔法学院的退学生",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20confident%20teenage%20mage%20holding%20a%20glowing%20spellbook%20in%20a%20grand%20library%20with%20floating%20candles%2C%20warm%20orange%20light%2C%20cel%20shaded%20fantasy%20anime%20poster%2C%20portrait&width=600&height=840&seq=anime-cover-15&orientation=portrait",
    year: 2026,
    region: "日本",
    categories: ["奇幻", "校园", "热血"],
    episodes: 13,
    status: "连载中",
    rating: 9.0,
    popularity: 8650,
    summary: "被学院开除的第一天，他就在校门口开了一家魔法补习班。学生越来越多，学院的麻烦也越来越大。",
    updatedAt: "2026-10-17",
    studio: "星屑学园",
    voiceCast: ["神代光", "雨宫纱良"],
    colorTag: "from-primary-500 to-secondary-700",
  },
  {
    id: "ocean-call-16",
    title: "深海回声",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20diver%20descending%20into%20a%20glowing%20deep%20sea%20with%20ancient%20ruins%2C%20teal%20water%20with%20warm%20amber%20highlights%2C%20cel%20shaded%20adventure%20anime%20poster%2C%20portrait%20composition&width=600&height=840&seq=anime-cover-16&orientation=portrait",
    year: 2025,
    region: "欧美",
    categories: ["冒险", "科幻", "悬疑"],
    episodes: 10,
    status: "已完结",
    rating: 8.6,
    popularity: 5780,
    summary: "海面下三千米传来规律的敲击声，像是有人在等待回应。一支深海调查队，带着一台老旧的录音机下潜。",
    updatedAt: "2026-09-02",
    studio: "蓝洞影业",
    voiceCast: ["Ava Reed", "Miles Cole"],
    colorTag: "from-primary-700 to-primary-900",
  },
  {
    id: "pastry-girl-17",
    title: "甜品魔法师",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cheerful%20young%20pastry%20chef%20decorating%20cakes%20in%20a%20sunny%20bakery%2C%20colorful%20desserts%2C%20warm%20pastel%20light%2C%20cel%20shaded%20slice%20of%20life%20anime%20poster%2C%20portrait&width=600&height=840&seq=anime-cover-17&orientation=portrait",
    year: 2024,
    region: "韩国",
    categories: ["日常", "治愈", "搞笑"],
    episodes: 14,
    status: "已完结",
    rating: 8.1,
    popularity: 4210,
    summary: "每做一个甜点，就会实现一个小心愿。她只是想在街角开一家小店，结果门口排起了整条街的队。",
    updatedAt: "2026-08-11",
    studio: "糖霜工作室",
    voiceCast: ["金多恩", "朴夏天"],
    colorTag: "from-accent-300 to-accent-600",
  },
  {
    id: "shadow-ninja-18",
    title: "雾隐之刃",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20lone%20ninja%20standing%20on%20a%20misty%20rooftop%20under%20a%20pale%20moon%2C%20flowing%20scarf%2C%20dramatic%20navy%20and%20orange%20lighting%2C%20cel%20shaded%20action%20anime%20poster%2C%20portrait&width=600&height=840&seq=anime-cover-18&orientation=portrait",
    year: 2021,
    region: "日本",
    categories: ["热血", "武侠", "冒险"],
    episodes: 24,
    status: "已完结",
    rating: 8.7,
    popularity: 7050,
    summary: "忍者的职责是消失于雾中，而他偏偏被所有人记住。一个背着旧刀的年轻人，一步步走向自己被抹去的过去。",
    updatedAt: "2025-12-20",
    studio: "雾隐社",
    voiceCast: ["影山岚", "佐久间白"],
    colorTag: "from-primary-800 to-secondary-800",
  },
];